export default "__VITE_ASSET__2162ef62__"